import dayjs from "dayjs";
import { get, isNil } from "lodash-es";
import numeral from "numeral";

/**
 * @description 格式化日期字符串
 * @param {String} date
 * @param {String} format
 * @returns {String} YYYY-MM-DD HH:mm:ss
 */
export const formatDateStr = (date, format = "YYYY-MM-DD HH:mm:ss") => {
  if (!date) {
    return "";
  }
  return dayjs(date).format(format);
};

/**
 * @description 格式化金额
 * @param {*} amount
 * @param {*} format
 * @returns
 */
export const formatAmount = (amount, format = "0,0.00") => {
  if (isNil(amount) || amount === "") {
    return "";
  }
  return numeral(amount).format(format);
};

/**
 * 处理浮点数的0
 * @param {*} num
 * @param {*} epsilon
 * @returns
 */
export const fixFloat = num => {
  if (isNaN(num)) return num;
  return +num.toFixed(2);
};
